import { render } from "./BaseCheckBox.vue?vue&type=template&id=39c0a41d"
import script from "./BaseCheckBox.vue?vue&type=script&lang=js"
export * from "./BaseCheckBox.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__